import React from 'react';
import { getBatteryStatusClass, formatPercent } from '../utils/transformersCompetition';

// Battery outline glyph with a charge-level fill, so it reads correctly even standalone
// (e.g. the TV roster, which has no separate meter bar next to it). Inherits color via
// currentColor so both outline and fill always match the surrounding status color
// (good/warning/critical/locked) for free.
export function BatteryIcon({ size = 12, className = '', style = {}, pct = 0, isStasisLocked = false }) {
  const clampedPct = isStasisLocked ? 0 : Math.max(0, Math.min(100, pct ?? 0));
  // Interior fill area sits inside the outline's stroke; give it a sliver of width at any
  // non-zero charge so "almost empty" is still visibly distinct from "empty".
  const fillWidth = clampedPct > 0 ? Math.max(1, (14 * clampedPct) / 100) : 0;

  return (
    <svg
      viewBox="0 0 22 12"
      width={size}
      height="auto"
      className={className}
      style={{ flexShrink: 0, aspectRatio: '22 / 12', ...style }}
      aria-hidden="true"
    >
      <rect x="1" y="1" width="18" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <rect x="20" y="4" width="2" height="4" rx="1" fill="currentColor" />
      {fillWidth > 0 && <rect x="3" y="3" width={fillWidth} height="6" rx="1" fill="currentColor" />}
    </svg>
  );
}

function BatteryMeter({ battery, isStasisLocked = false }) {
  const statusClass = getBatteryStatusClass(battery, isStasisLocked);
  const pct = isStasisLocked ? 0 : Math.max(0, Math.min(100, battery ?? 0));

  return (
    <div className="tc-battery-meter">
      <div className="tc-battery-meter-track">
        <div className={`tc-battery-meter-fill ${statusClass}`} style={{ width: `${pct}%` }} />
      </div>
      <span className={`tc-battery-meter-label ${statusClass}`}>
        <BatteryIcon pct={pct} isStasisLocked={isStasisLocked} />
        {isStasisLocked ? 'Stasis Lock' : formatPercent(battery)}
      </span>
    </div>
  );
}

export default BatteryMeter;
